import { Map, fromJS } from "immutable";
export const SHIPPING_ORDER_TYPE = "shipping_order";
export const SALES_ORDER_TYPE = "sales_order";
export const SUBSCRIPTION_TYPE = "subscription";
export const META_ORDER_TYPE = "meta_order";

export function allStatuses() {
  return fromJS([
    { id: "open", name: "Open", color: "var(--white)", background: "#ff7e00" },
    { id: "resolved", name: "Resolved", color: "var(--white)", background: "00bc34" }
  ]);
}

export function getStatusFromId(id) {
  let result = allStatuses().find(status => status.get("id") === id)
  if (result && Map.isMap(result)) return result;
  return Map({});
}

export function allTags() {
  return fromJS([
    { id: "urgent", name: "Urgent", color: "var(--white)", background: "var(--red)" },
    { id: "bug", name: "Bug", color: "var(--white)", background: "var(--black)" },
    { id: "not_delivered", name: "Not Delivered", color: "var(--white)", background: "var(--accent-blue-700)" },
    { id: "billing_issue", name: "Billing", color: "var(--white)", background: "rgb(199,5,198)" },
  ]);
}

export function getTagFromId(id) {
  let result = allTags().find(tag => tag.get("id") === id)
  if (result && Map.isMap(result)) return result;
  return Map({});
}

export function linkForType(type, id) {
  switch(type) {
    case SHIPPING_ORDER_TYPE:
      return Map({path: `/shipping/orders/${id}`, title: "Shipping Order"});
    case SALES_ORDER_TYPE:
      return Map({path: `/sales/orders/${id}`, title: "Sales Order"});
    case SUBSCRIPTION_TYPE:
      return Map({path: `/subscriptions/${id}`, title: "Subscription"});
    case META_ORDER_TYPE:
      return Map({path: `/sales/metaOrders/${id}`, title: "Meta Order"});
    default:
      return Map();
  }
}